<div class="search" #searchContainer>
  <img class="search-icon" src="assets/icons/search.svg" alt="search">
  @if (searchResultsCount()) {
    <img
      (click)="close()"
      class="search-close"
      src="assets/icons/close_red_24dp.svg"
      alt="search-close">
  }
  <input class="search-input form-control"
    [formControl]="searchControl"
    [placeholder]="'search.searchByIdentifier' | translate" />

  @if (searchResultsCount()) {
    <ol class="help-text">
      @for (workOrder of workOrdersFiltered | slice:0:maxResults; track $index; let i = $index) {
        <li
          class="search-item"
          tabindex="0">
          <div (click)="click(workOrder)" class="help-text-open">
            {{ workOrder.identifier }}
            @if (workOrder.search_type === searchTypes.STANDARD) {
              <span class="work-order-type">
                ({{ 'basic.frame' | translate }})
              </span>
            }
            @if (workOrder.search_type === searchTypes.INVERTER) {
              <span class="work-order-type">
                ({{ 'basic.inverter' | translate }})
              </span>
            }
            @if (workOrder.search_type === searchTypes.TYPE3) {
              <span class="work-order-type">
                ({{ 'basic.type3WorkOrder' | translate }})
              </span>
            }
            @if (workOrder.search_type === searchTypes.POWERLINE) {
              <span class="work-order-type">
                ({{ 'basic.powerline' | translate }})
              </span>
            }
          </div>
          @if (showExtraInfo && (workOrder.transformer || workOrder.inverter || workOrder.circuit)) {
            <div
              (click)="click(workOrder)">
              @if (workOrder.transformer) {
                <span>{{ workOrder.transformer }}</span>
              }
              @if (workOrder.inverter) {
                <span class="ms-1">
                  @if (workOrder.transformer) {
                    -
                  }
                  {{ workOrder.inverter }}
                </span>
              }
              @if (workOrder.circuit) {
                <span class="ms-1">
                  @if (workOrder.transformer || workOrder.inverter) {
                    -
                  }
                  {{ workOrder.circuit }}
                </span>
              }
            </div>
          }
          <hr>
          </li>
        }
        <div class="search-count">
          {{ 'search.searchResults' | translate }}: {{ searchResultsCount() }}
        </div>
      </ol>
    }
  </div>
